import React from "react";
import { ArrowRight, MapPin } from "lucide-react";

const Hero = () => {
  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      className="hero-bg min-h-screen flex items-center relative overflow-hidden"
      data-testid="hero-section"
    >
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/40 via-[#0A0A0A]/70 to-[#0A0A0A]" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-32 lg:py-0 relative z-10">
        <div className="flex flex-col-reverse lg:grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content - Shows first on mobile */}
          <div className="fade-in-up">
            {/* Trust badge */}
            <div className="inline-flex items-center gap-2 mb-6 px-4 py-2 bg-[#FFD84D]/10 border border-[#FFD84D]/20 rounded-full">
              <MapPin className="w-4 h-4 text-[#FFD84D]" />
              <span className="text-sm text-[#FFD84D] font-medium">
                Lanseres nå i Fredrikstad og Sarpsborg
              </span>
            </div>

            {/* Headline */}
            <h1 className="text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-extrabold tracking-tighter text-white mb-6 font-['Outfit'] leading-[0.9]">
              Tom for strøm?
              <br />
              <span className="text-[#FFD84D]">Vi fikser det.</span>
            </h1>

            {/* Subtext */}
            <p className="text-xl md:text-2xl text-[#A1A1AA] mb-10 max-w-xl leading-relaxed">
              Lei powerbank på sekunder – rett fra stasjonen.
            </p>

            {/* CTA */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="#contact"
                onClick={(e) => scrollToSection(e, "#contact")}
                className="btn-primary flex items-center justify-center gap-2 group text-lg px-8 py-4"
                data-testid="hero-cta-primary"
              >
                Få en stasjon hos deg
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </a>
            </div>
          </div>

          {/* Product Image */}
          <div className="relative fade-in flex justify-center lg:justify-end" style={{ animationDelay: "0.3s" }}>
            <div className="relative">
              {/* Glow effect behind image */}
              <div className="absolute inset-0 bg-[#FFD84D]/20 blur-3xl rounded-full scale-75" />
              <img
                src="https://static.prod-images.emergentagent.com/jobs/34039477-a207-4dc8-98b5-a0f0d25d9137/images/9a1752ee278ab3c3e60e4bdeadc10ab1f54d5a94625152cfce8191291a4e592b.png"
                alt="B-Labs Powerbank Station"
                className="relative z-10 w-full max-w-md lg:max-w-lg xl:max-w-xl object-contain drop-shadow-2xl"
                data-testid="hero-product-image"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-xs text-[#A1A1AA]">Scroll</span>
        <div className="w-6 h-10 border-2 border-[#A1A1AA]/30 rounded-full flex justify-center pt-2">
          <div className="w-1.5 h-3 bg-[#FFD84D] rounded-full" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
